export interface IBillingAddress {
  street1: string;
  street2: string;
  city: string;
  postal_code: string;
  country: string;
  state_province?: string;
}

export interface IOnlineApplication {
  id: number;
  applicationId: number;
  accountId?: string;
  securityKey: string;
  completedPageId: AppStageId;
  pathway: "Eligibility" | "Training" | "Recommendation";
  forenames: string;
  surname: string;
  email: string;
  dateOfBirth?: string;
  mobileNumber: string;
  landlineNumber: string;
  currentMember: IBooleanValue;
  currentName: string;
  appearingNowPublicationCode?: number;
  currentEmail: string;
  playingAgeFrom?: number;
  playingAgeTo?: number;
  publishAge: IBooleanValue;
  gender?: number;
  customOrNonBinaryGender?: number;
  showGenderOnProfile: IBooleanValue;
  deafOrDisabled: IBooleanValue;
  furtherInformation: string;
  marketing: IMarketing;
  photograph: IPhotoInformation;
  recommendation?: IRecommendation;
  credits: ICredit[];
  courses: ICourse[];
  membershipOptions: number[];
  agents: number[];
  modernJourney: boolean;
  parentSurname?: string;
  parentForenames?: string;
  performerType?: number;
  isOrganisationMember?: boolean;
  isCDApplication?: boolean;
  address: IBillingAddress;
}

export interface IMarketing {
  emailPreferences: string[];
  thirdParties: string;
  sms: string;
  phone: string;
}

export interface ICDApplication {
  id: string;
  securityKey: string;
  title: string;
  forename: string;
  surname: string;
  company: string;
  postcode: string;
  phone: string;
  mobile: string;
  fax: string;
  email: string;
  website: string;
  vatNumber: string;
  business: string;
  companyInformation: string;
  membershipName: string;
  membershipEmail: string;
  membershipNumber: string;
  previousSpotlightMemberName: string;
  previousSpotlightMemberRegisteredEmail: string;
  previousSpotlightMemberType: string;
  experience: string;
  occupation: string;
  useSpotlightFor: string;
  useSpotlightForNotSureDetails: string;
  castingForUnder18: string;
  castingForUnder18Aware: string;
  cvS3ObjectKey: string;
  cvS3ObjectUrl: string;
  links: string[];
  marketingPreferences: IMarketing;
  organisationLookUpId: number;
  occupationLookUpId: number;
  useSpotlightForLookUpId: number;
  addressInfo: IBillingAddress;
}

export interface IPhotoInformation {
  photoKey: string;
  photographerName: string;
  photoDescription: string;
}

export interface IRecommendation {
  refereeName: string;
  refereeMembership: string;
  s3ObjectKey: string;
}

export interface ICredit {
  productionName: string;
  type?: number;
  roleName: string;
  company: string;
  director: string;
  creditLink: string;
  dateFrom?: string;
  dateTo?: string;
  s3ObjectKey: string;
  equityRole: IBooleanValue;
}

export interface ICourse {
  schoolName: string;
  courseName: string;
  dateFrom?: string;
  dateTo?: string;
  qualificationLevel?: number;
  courseUrl: string;
  s3ObjectKey: string;
  courseType?: "fullTime" | "partTime";
}

type IBooleanValue = "yes" | "no" | "";

export enum AppStageId {
  AboutYou = 2,
  Review = 10,
  Finished = 12,
  Welcome = 27,
  Pathway = 28,
  Eligibility = 29,
}

export enum BillingAccountTypes {
  Performer = "performer",
  YoungPerformer = "yp",
  Casting = "casting",
  Graduate = "grad",
}
